import App from "@frog/source/models/App.js"

import StepAnimation from "@frog/source/engine/animating/StepAnimation.js"

const SPEED = 1 // for debugging animations

export default new class Director {
    constructor() {
        this.steps = []
    }
    get isPerforming() {
        return App.sequence?.steps != undefined
            && App.sequence.steps.length > 0
    }
    // Director.updateSequence({sequence, delta})
    // const sequence = {
    //     "isLooping": true,
    //     "steps": [step, step, step]
    // }
    // TODO: Combine with App.js Sequence
    updateSequence({sequence, delta, isMuted}) {
        if(sequence == undefined) return
        if(sequence.isInstantiated != true) {
            sequence.isInstantiated = true
            sequence.steps = sequence.steps.map((step) => {
                return StepAnimation.instantiate(StepAnimation.copy(step))
            })
        }

        // if(step.isPosted != true) {
        //     step.isPosted = true
        //     console.log(step)
        // }

        const MAX_STEPS_PER_FRAME = 30
        for(let index = 0; index <= MAX_STEPS_PER_FRAME; index += 1) {
            let step = sequence.steps[0]
            if(step == undefined) return
            step.time += delta.ms * SPEED

            if(step.func != undefined) {
                let extrasteps = step.func(step.alphastage)
                Sequence.shift(sequence)
                if(extrasteps != undefined) {
                    // BE WARNED! These extra steps don't affect
                    // the end stage, because that stage has been
                    // precomputed long before it was sent to the
                    // director.
                    // TODO: Either make this work, or make ink dialogue just return steps.
                    if(extrasteps instanceof Array == false) {
                        extrasteps = [extrasteps]
                    }
                    extrasteps = extrasteps.map((extrastep) => StepAnimation.instantiate(StepAnimation.copy(extrastep)))
                    sequence.steps = extrasteps.concat(sequence.steps)
                }
            } else if(step.animation != undefined) {
                StepAnimation.executeAnimation({
                    "stage": step.stage,
                    "animation": step.animation,
                    "currentDuration": step.time,
                    "isMuted": isMuted
                })

                if(step.time >= step.animation.maxmark) {
                    Sequence.shift(sequence)
                } else {
                    return
                }
            } else if(step.duration != undefined) {
                step.stage = step.omegastage // THIS SHOULD BE HAPPENING IN AN ANIMATION!!
                if(step.time >= step.duration) {
                    Sequence.shift(sequence)
                } else {
                    return
                }
            } else {
                Sequence.shift(sequence)
            }
        }
    }
}

// Combine with App.js Sequence
class Sequence {
    static shift(sequence) {
        const step = sequence.steps.shift()
        if(sequence.isLooping == true) {
            sequence.steps.push(StepAnimation.instantiate(step))
        }
    }
}




// Not yet in v2 schema.
// Not that it needs to be.
// But just listing it here
// for posterity.
// - isAnimating
// - rotation
// - grayscale
